/* eslint-disable consistent-return */
import {
  DefaultButton,
  HeaderPage,
  NewModal,
  Toggle,
  Loading,
  SearchBarComponent,
  Kanban2,
  SearchMenu,
} from 'components/index'
import { useContext, useEffect, useState } from 'react'
import { IObject } from 'interfaces'
import { UserContext } from 'context'
import { useFetch, useStorage } from 'hooks'
import { Icon } from 'assets/index'
import { hasAccess, optionsLevels } from 'helper/utils'
import { PageScrollContent } from 'styles/index'
import * as modals from './Modal'
import { Container } from './style'

export default function Captacao() {
  const {
    showModal,
    setShowModal,
    toggleCap,
    setData,
    selectedId,
    checkbox,
    page,
    setPage,
    setToggleCap,
    setCheckbox,
    setPreview,
  } = useContext(UserContext)
  const [user] = useStorage('User')
  const [modalData, setModalData] = useState<any>([])
  const [kanbanData, setKanbanData] = useState<any[]>([])
  const [filteredKanbanData, setFilteredKanbanData] = useState<any[]>([])
  const [toggleKanban, setToggleKanban] = useState<any>('enterprise')
  // const [page, setPage] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [searchName, setSearchName] = useState<string>('')
  const [searchMenuIsExpanded, setSearchMenuIsExpanded] = useState(false) // abrir e fechar o menu de busca
  const api = useFetch()

  function fetch(target: string) {
    setLoading(true)
    api
      .fetch('get', null, `/gestor/kanban/${target}`)
      .then((response: any) => {
        if (!response.data) return
        const kanban = response.data.data
        setKanbanData(kanban)
        setLoading(false)
      })
      .catch((err) => {
        console.log(err)
        setLoading(false)
      })
  }

  useEffect(() => {
    if (toggleKanban === 'enterprise') {
      return fetch('enterprise')
    }
    return fetch('captations')
  }, [toggleKanban])

  useEffect(() => {
    console.log('nivel user', optionsLevels[user.level])
    if (!showModal) {
      toggleKanban === 'enterprise' ? fetch('enterprise') : fetch('captations')
      setToggleCap('Proposta base')
      if (
        optionsLevels[user.level] === 'SPECIALIST' ||
        optionsLevels[user.level] === 'SPECGESTOR'
      ) {
        console.log('ta chamando e aqui')
        setToggleCap('Proposta personalizada')
        setCheckbox(true)
      }
      return setPage(0)
    }
  }, [showModal])

  useEffect(() => {
    if (typeof toggleCap !== 'string') return
    switch (toggleCap) {
      case 'Investimento realizado':
        return setModalData(modals.baseCaptacao)
      case 'Proposta personalizada':
        setModalData(checkbox ? modals.baseCaptacao : modals.novaCaptacao)
        return
      case 'Captação aberta':
        return setModalData(modals.novaCaptacao)
      default:
    }

    return () => {
      setModalData(modals.novaCaptacao)
    }
  }, [toggleCap, checkbox])

  const formatName = (str: string) => {
    return str
      .toLowerCase() // Converte para minúsculas
      .normalize('NFD') // Normaliza a string para a forma de decomposição canônica NFD
      .replace(/[\u0300-\u036f]/g, '') // Remove os acentos
      .trim() // Remove espaços no início e no fim
  }
  useEffect(() => {
    // *************************************************************
    // FILTRAR DADOS DO KANBAN
    // *************************************************************
    const filters: ((card: any) => boolean)[] = [] // Lista de funções de filtro

    const applyFilters = (dataFilter: any[]) => {
      return dataFilter.map((column: any) => ({
        ...column,
        cardList: column.cardList.filter((card: any) =>
          filters.every((filter) => filter(card))
        ),
      }))
    } // Aplica todos os filtros

    if (searchName) {
      filters.push((card: any) =>
        formatName(card?.name).includes(formatName(searchName))
      )
    }

    const filteredData = applyFilters(kanbanData)

    setFilteredKanbanData(filteredData)
  }, [kanbanData, searchName, setFilteredKanbanData])

  const novaCaptacao = () => {
    setData({})
    setPreview('')
    setModalData(modals.novaCaptacao)
    setShowModal(true)
  }

  const novoEmpreendimento = () => {
    setData({})
    setPreview('')
    // setModalData(modals.novoEmpreendimento)
    setModalData(modals.newEmpreendimento)
    setShowModal(true)
  }

  const openCaptacao = async (card?: IObject) => {
    if (!card) return
    selectedId.current = card.id
    if (toggleKanban === 'enterprise') {
      setModalData(modals.empreendimentoEscolhido)
    } else {
      setModalData(modals.captacaoEscolhida)
    }
    setShowModal(true)
  }

  return (
    <Container isExpanded={searchMenuIsExpanded}>
      <PageScrollContent flexDirection="row">
        <SearchMenu
          setIsExpanded={setSearchMenuIsExpanded}
          isExpanded={searchMenuIsExpanded}
        >
          <div className="captacao-left-container">
            <DefaultButton
              id="new-enterprise-button"
              onClick={novoEmpreendimento}
              icon={Icon('plus.svg')}
              small
              disabled={
                !hasAccess('new-enterprise-button')
                // !['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level]) ||
                // user?.permission === 'READ'
              }
            >
              Empreendimento
            </DefaultButton>
            <DefaultButton
              onClick={novaCaptacao}
              icon={Icon('plus.svg')}
              small
              disabled={
                !hasAccess('new-captation-button')
                // !['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level]) ||
                // user?.permission === 'READ'
              }
            >
              Nova captação
            </DefaultButton>
            <SearchBarComponent
              width="small"
              dataTestId="search-name"
              placeholder={'Nome'}
              onChange={(e: any) => {
                setSearchName(e.target.value)
              }}
            />
          </div>
        </SearchMenu>
        <div className="captacao-right-container">
          <HeaderPage
            path={
              toggleKanban === 'enterprise' ? 'Empreendimentos' : 'Captações'
            }
          />

          <div
            className="captacao-toggle-container"
            data-testid={`toggle-enterprise-captation`}
          >
            <Toggle
              toggle={toggleKanban}
              setToggle={setToggleKanban}
              options={[
                ['Empreendimentos', 'enterprise'],
                ['Captações', 'captations'],
              ]}
            />
          </div>

          <div className="container-kanban">
            {filteredKanbanData && filteredKanbanData.length > 0 && !loading ? (
              <Kanban2
                height="100%"
                notDraggable={
                  !hasAccess('products-kanban-draggable')
                  // optionsLevels[user.level] === 'SPECIALIST' ||
                  // optionsLevels[user.level] === 'SPECGESTOR' ||
                  // optionsLevels[user.level] === 'GESTOR'
                }
                handleClick={openCaptacao}
                investCard
                data={filteredKanbanData}
                setData={setFilteredKanbanData}
                isEnterprise={toggleKanban === 'enterprise'}
              />
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: window.innerHeight - 280,
                  width: '100%',
                }}
              >
                <Loading modal />
              </div>
            )}
          </div>
        </div>
      </PageScrollContent>

      {/* <Modal showModal={showModal} setShowModal={setShowModal}>
        {modalData}
      </Modal> */}
      <NewModal showModal={showModal} setShowModal={setShowModal}>
        {modalData}
      </NewModal>
    </Container>
  )
}
